export default "__VITE_ASSET__CbGIFJof__"